/**************************************************
 * Nombre:       Dona_Limpia
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Chart from "react-apexcharts";
import {COLORES, TEXTO} from "../ContantesColorGraficas";

const Barras_Horizontales_Nombre = ({ancho, labels = [], series=[], marginTop=0, height='auto'}) => {
    const options = {
        chart: {
            id: "bar-bare",
            sparkline: {
                enabled: false,
            },
            toolbar:{
                show: false
            }
        },
        labels: labels,
        stroke: {
            width: 0,
            curve: 'smooth'
        },
        colors: COLORES,
        plotOptions: {
            bar: {
                borderRadius: 6,
                dataLabels: {
                    position: 'top', // top, center, bottom
                },
            }
        },
        dataLabels: {
            enabled: true,
            offsetY: 0,
            style: {
                fontSize: '12px',
                colors: [TEXTO]
            }
        },
        xaxis: {
            labels:{
                show: true
            },
            axisBorder:{
                show: false
            },
            axisTicks: {
                show: false,
            },
            axisLabels: {
                show: false
            }

        }


    }



    return (
        <Chart
            options={options}
            series={series}
            type="bar"
            width={ancho}
            height={height}
            style={{marginTop:marginTop}}
        />
    )

}
export default Barras_Horizontales_Nombre